import * as angular from 'angular';
import { downgradeComponent } from '@angular/upgrade/static';

import { BulkSettingsComponent } from './bulk-settings.component';
import { BulkSettingsRouter } from './bulk-settings.router';

/** @constant {angular.module} */
const bulkSettingsModule = angular
  .module('ec.opsCenter.ops-support.settings', [])
  .config(BulkSettingsRouter)
  .directive('appBulkSettings', downgradeComponent({ component: BulkSettingsComponent }) as angular.IDirectiveFactory).name;

export default bulkSettingsModule;



// WEBPACK FOOTER //
// ./src/app/ops-support/settings/bulk-settings.module.ajs.ts